import { render, staticRenderFns } from "./modalCrearTitulo.vue?vue&type=template&id=23b460b0&scoped=true&"
import script from "./modalCrearTitulo.vue?vue&type=script&lang=js&"
export * from "./modalCrearTitulo.vue?vue&type=script&lang=js&"
import style0 from "./modalCrearTitulo.vue?vue&type=style&index=0&id=23b460b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b460b0",
  null
  
)

export default component.exports